document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('ul.shopify-tabs > li').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var tab_id = tab.getAttribute('data-tab');

      // Remove 'current' class from all tabs and tab contents
      tab.parentElement.querySelectorAll('li').forEach(function (li) {
        li.classList.remove('current');
      });
      document
        .querySelectorAll('.shopify-tab-content')
        .forEach(function (content) {
          content.classList.remove('current');
        });

      // Add 'current' class to the clicked tab and the corresponding tab content
      tab.classList.add('current');
      document.getElementById(tab_id).classList.add('current');
    });
  });
});
